// Angular Files
import { Component, Inject, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

// Teller Online Files
import { VgsCollectCvvOnlyComponent } from 'apps/public-portal/src/app/payment-integrations/base/components';

// Teller Online Library Files
import { TellerOnlineMessageService } from 'teller-online-libraries/shared';

export interface CvvPromptDialogData {
    vgsVaultId: string;
    vgsEnvironment: string;
    vgsVersion: string;
}

/**
 * Modal dialog that prompts the user for the CVV of a saved card so the
 * Generic processor can lazy-re-tokenize it against any cart partitions whose
 * plugin doesn't yet hold a token row for the saved wallet id (Phase 5).
 *
 * Closes with the captured CVV token on confirm; closes with `null` when the
 * user cancels (which the caller treats as "abort pay"). PCI-scope: never
 * persisted server-side; the token only lives in transit on the re-tokenize
 * call and is discarded after the plugin acks.
 */
@Component({
    selector: 'app-cvv-prompt-dialog',
    templateUrl: './cvv-prompt-dialog.component.html',
    styleUrls: ['./cvv-prompt-dialog.component.scss'],
    host: {
        class: 'cvv-prompt-dialog'
    }
})
export class CvvPromptDialogComponent {
    @ViewChild(VgsCollectCvvOnlyComponent) public cvvCollect: VgsCollectCvvOnlyComponent;

    public submitting = false;

    private _capturedCvvToken: string = null;

    constructor(
        public dialogRef: MatDialogRef<CvvPromptDialogComponent, string | null>,
        @Inject(MAT_DIALOG_DATA) public data: CvvPromptDialogData,
        private messageService: TellerOnlineMessageService,
    ) { }

    public onCvvCaptured_storeForConfirm(cvvToken: string): void {
        this._capturedCvvToken = cvvToken;
    }

    public async onClick_confirm(): Promise<void> {
        if (this.submitting) return;
        this.submitting = true;

        try {
            await this.cvvCollect.submitAndMapVGSFields();
            // submitAndMapVGSFields fires `cvvCaptured` synchronously inside the
            // await, populating `_capturedCvvToken` before resolution.
            this.dialogRef.close(this._capturedCvvToken);
        } catch {
            this.submitting = false;
            this.messageService.notification(
                'Please re-enter your CVV.', 'error', 5000);
        }
    }
}
